import React from 'react';

const JS_2019 = () => {
  return (
    <div >
      <h1>JS_2019</h1>
      <p>Placeholder component for: "JS 2019"</p>
    </div>
  );
};

export default JS_2019;
